import { Injectable } from '@angular/core';
import { CustomerSelectorFactoryPluginService } from '../../customerselector/customerselector-plugin-factory.service';

@Injectable()
export class InstallationCustomerInfoFactoryPluginService extends CustomerSelectorFactoryPluginService {}
